// extracted by mini-css-extract-plugin
export var avatarContainer = "_af-0";
export var avatarTypingWave = "_af-i";
export var gray = "_af-f";
export var green = "_af-c";
export var icon = "_af-9";
export var image = "_af-1";
export var lg = "_af-6";
export var md = "_af-5";
export var presenceDot = "_af-b";
export var red = "_af-d";
export var sm = "_af-4";
export var status = "_af-a";
export var typingDot = "_af-h";
export var typingPill = "_af-g";
export var xl = "_af-7";
export var xs = "_af-3";
export var xxl = "_af-8";
export var xxs = "_af-2";
export var yellow = "_af-e";